module.exports = __webpack_public_path__ + "img/v4_followDetail.6061a764.png";